import React, { useEffect, memo } from 'react'
import SettingsIcon from '@mui/icons-material/Settings'
import TabDataTools from './TabDataTools'

const DatabaseFunctions = memo(function DatabaseFunctions(props) {
    useEffect(() => {
        document.title = 'BI Cloud - Data Tools'
    }, [])

    return (<div className="mainWrapper">
        <div className="bodyPart">
            <div className="contentWrapper">
                <h2 className="pageHead">
                    <SettingsIcon />
                    {' '}
                    Database Functions
                </h2>
                <div className="tabOutMain">
                    <TabDataTools
                        dbList={props.dbList}
                        getDataSources={props.getDataSources}
                        showPopup={props.showPopup}
                        jobs={props.jobs}
                        histories={props.histories}
                        globalFiles={props.globalFiles}
                        downloadFile={props.downloadFile}
                        role={props.role}
                        performingJob={props.performingJob}
                        jobProgressId={props.jobProgressId}
                        currentJobProgress={props.currentJobProgress}
                        currentJobTotalParts={props.currentJobTotalParts}
                        selfServiceChangeFilesPage={props.selfServiceChangeFilesPage}
                        selfServiceChangeJobsPage={props.selfServiceChangeJobsPage}
                        selfServiceChangeHistoriesPage={props.selfServiceChangeHistoriesPage}
                        openEditNewWizardFile={props.openEditNewWizardFile} />
                </div>
            </div>
        </div>
    </div>)
})

export default DatabaseFunctions